import React, { useContext, useEffect } from 'react';
import { withRoomContext } from '../../../RoomContext';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as roomActions from '../../../store/actions/roomActions';
import GradientButton from '../../customMui/newButton/newButton';
import deviceInfo from '../../../deviceInfo';
import ControllerContext from '../../../RoomControllerSocketContext';

function KickOut(props)
{
	// const {
	// 	roomClient
	// } = props;
	const device = deviceInfo();
	const { pluginSocket } = useContext(ControllerContext);
	const { roomClient } = props;  // ← This works because withRoomContext adds it


	function desktopNavigate()
	{
		try
		{
			if (window.location.host.includes('localhost'))
			{
				window.location = `${window.location.origin}/desktop_room`;
			}
			else
			{
				window.location = `https://${window.location.hostname}/desktop_room`;
			}
		}
		catch (error)
		{
			console.log('error in redirect to dashboard event==', error);
		}
	}

	const handleNavigate = () =>
	{
		if (device.platform === 'desktop' && device.name === 'electron')
		{
			pluginSocket?.emit('redirectToDashboard');
			desktopNavigate();
		}
		else
		{
			window.location.href = roomClient?._roomTemplate && roomClient?._roomTemplate?.data?.exitUrlStatus ?  roomClient?._roomTemplate.data.exitUrl : import.meta.env.VITE_config;
		}
	};

	useEffect(() =>
	{
		pluginSocket?.on('redirectToDashboard', () =>
		{
			if (device.platform === 'desktop' && device.name === 'electron')
			{
				desktopNavigate();
			}
		});

		return () =>
		{
			pluginSocket?.off('redirectToDashboard');
		};
	}, [ pluginSocket ]);

	useEffect(() =>
	{
		setTimeout(() =>
		{
			handleNavigate();
		}, 5000);
	}, []);

	return (
		<div className='flexCol dialogBD '>
			<div className='flexCol dialogBox pdngBMD'>
				<div className='flexRow jBtwn aCntr brdrBSM pdngMD'>
					<span className='lHdng pdngHXS'>Oops!</span>
					<div className='flexInline pdngHXS '>
						<img
							src='/images/cancel.svg'
							alt='cancel'
							className='IconImage pointer'
							onClick={handleNavigate}
						/>
					</div>
				</div>
				<div className='flexCol pdngMD aCntr jCntr'>
					<div className='flexRow pdngVMD jCntr'>
						<img src='/icons/oops.svg' alt='oops' />
					</div>
					<span className='pdngVMD sHdng'>You have been removed from the meeting.</span>
				</div>
				<div className='flexRow aCntr jCntr pdngVSM '>
					<GradientButton
						variant='contained'
						disableElevation
						color='primary'
						style={{ borderRadius: '10px' }}
						onClick={handleNavigate}
					>
						OK
					</GradientButton>
				</div>
			</div>
		</div>
	);
}

KickOut.propTypes =
{
	// roomClient              : PropTypes.object.isRequired,
	templateLeaveOpen       : PropTypes.bool.isRequired,
	handleSetModeratorLeave : PropTypes.func.isRequired,
	classes                 : PropTypes.object.isRequired,
	chatCount               : PropTypes.number.isRequired,
	setLeaveOpen            : PropTypes.func.isRequired,
	setCloseMeeting         : PropTypes.func.isRequired,
	streamingLiveOn         : PropTypes.bool.isRequired

};

const mapStateToProps = (state) =>
	({
		templateLeaveOpen : state.room.templateLeaveOpen,
		chatCount         : state.chat.count,
		streamingLiveOn   : state.room.streamingLiveOn
	});

const mapDispatchToProps = (dispatch) =>
	({
		handleSetModeratorLeave : (templateLeaveOpen) =>
		{
			dispatch(roomActions.setTemplateLeaveOpen(templateLeaveOpen));
		},
		setLeaveOpen : (leaveOpen) =>
		{
			dispatch(roomActions.setLeaveOpen(leaveOpen));
		},
		setCloseMeeting : (moderatorCloseMeeting) =>
		{
			dispatch(roomActions.setModeratorClose(moderatorCloseMeeting));
		}
	});

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.templateLeaveOpen === next.room.templateLeaveOpen &&
				prev.chat.count === next.chat.count &&
				prev.room.streamingLiveOn === next.room.streamingLiveOn
			);
		}
	}
)(KickOut));